import { createTransaction } from "./createTransaction";
import { getFormalizationUrl } from "./getFormalizationUrl";
import { getOffers } from "./offers";
import { postAuthorization } from "./postAuthorization";
import { postSimulation } from "./postSimulation";

export const c6BankService = {
  postAuthorization,
  postSimulation,
  createTransaction,
  getFormalizationUrl,
  getOffers,
};
